import { render, staticRenderFns } from "./SortByOptions.vue?vue&type=template&id=0a1b5b3c&scoped=true"
import script from "./SortByOptions.vue?vue&type=script&lang=js"
export * from "./SortByOptions.vue?vue&type=script&lang=js"
import style0 from "./SortByOptions.vue?vue&type=style&index=0&id=0a1b5b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b5b3c",
  null
  
)

export default component.exports